'use client';

import Script from 'next/script';
import { preconnect } from 'react-dom';

const ClarityScript = () => {
	const clarityId = process.env.NEXT_PUBLIC_CLARITY_ID || 's8o1nkrnoc';

	if (!clarityId) return null;

	preconnect('https://n.clarity.ms');

	return (
		<Script
			id="clarity-script"
			strategy="lazyOnload"
			dangerouslySetInnerHTML={{
				__html: `
					(function(c,l,a,r,i,t,y){
						c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
						t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
						y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
					})(window, document, "clarity", "script", "${clarityId}");
				`
			}}
		/>
	);
};

export default ClarityScript;
